export default "__VITE_ASSET__Bxd7mwDu__"